export const PRESET_SIZES = {
	sm: { w: 80, h: 80 },
	md: { w: 300, h: 144 },
	lg: { w: 600, h: 316 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = [
	'alfaromeo_giulia',
	'audi_3sedan',
	'audi_rs4avant',
	'audi_rs5',
	'audi_rs6c6',
	'audi_rs7',
	'audi_rs7c7',
	'audi_s8plus',
	'bmw_5e39',
	'bmw_5g30',
	'bmw_7e38',
	'bmw_m2f87',
	'bmw_m2g87',
	'bmw_m3g80',
	'bmw_m4f82',
	'bmw_m5e39',
	'bmw_m5e60',
	'bmw_m5f10',
	'bmw_m5f90',
	'bmw_m5g90',
	'bmw_m750li',
	'bmw_x5me70',
	'bmw_x5mf95',
	'bmw_x6mf86',
	'bugatti_veyron',
	'cadillac_escalade',
	'cadillac_escalade2',
	'chevrolette_corvettezl1',
	'chevrolette_elcamino',
	'dodge_hellcat',
	'dodge_magnum',
	'dodge_ramtrx',
	'dodge_viper',
	'ferrari_sf90',
	'ferrari_sf90xx',
	'ford_bronco',
	'ford_mustang21',
	'ford_raptor',
	'ford_shelby500',
	'gaz_2410',
	'gmc_sierra',
	'gmc_vandura',
	'honda_ek9',
	'honda_nsx',
	'jeep_trackhawk',
	'kia_stinger',
	'lada_2107',
	'lada_2121',
	'lamborghini_urus',
	'landrover_405',
	'landrover_rangerover_svr',
	'lexus_lfa',
	'lexus_lx470',
	'mazda_3mps',
	'mazda_rx7',
	'mercedes_amg_gt24',
	'mercedes_c63',
	'mercedes_c63coupe',
	'mercedes_cls218',
	'mercedes_cls257',
	'mercedes_e63',
	'mercedes_e63s',
	'mercedes_g500',
	'mercedes_gt63s',
	'mercedes_s63cabrio',
	'mercedes_s63w222',
	'mercedes_sl63',
	'mercedes_w211',
	'mercedes_w214',
	'mercedes_w221s600',
	'mercedes_w223',
	'mercedes_w447',
	'nissan_r34',
	'nissan_r35',
	'nissan_z21',
	'porsche_911carrera',
	'porsche_cayennetrbs',
	'porsche_panamera',
	'porsche_taycan',
	'skoda_octaviars',
	'toyota_ae86',
	'toyota_xv55',
	'toyota_xv70',
] as const;
